module.exports = __webpack_public_path__ + "static/screenshot-my-source-nutrition-34e3040d0a36ff739a5d93bdb54111b0.png";